import '../applied_filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedHashtagView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView
  className: 'text'
  name: 'hashtags'
  hasLogicSelector: true

  getDescription: (value) ->
    return "##{value}"

  removeFilter: (value) ->
    @searchQuery.removeHashtag(value)



